import { Link } from "react-router-dom";
import { Instagram, Mail } from "lucide-react";
import { WaitlistForm } from "@/components/WaitlistForm";

export const Footer = () => (
  <footer className="bg-maroon text-cream mt-24">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-4">
      <div className="md:col-span-2">
        <img
          src="https://customer-assets.emergentagent.com/job_george-henry-co/artifacts/nhrp8pqj_HOUND%20OZ%20logo1.png"
          alt="Hound Oz — Designed in Australia"
          className="h-24 w-auto rounded-2xl"
        />
        <p className="mt-6 text-cream/70 max-w-sm leading-relaxed">
          Cosy essentials for dog lovers, inspired by our two basset hounds, George &amp; Henry.
          Made for you and your hound.
        </p>
        <div className="flex gap-4 mt-6">
          <a href="https://instagram.com/hound.oz" target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="social-instagram" className="text-cream/70 hover:text-cream transition-colors">
            <Instagram className="w-5 h-5" strokeWidth={1.5} />
          </a>
          <a href="mailto:houndoz@outlook.com" aria-label="Email" data-testid="social-email" className="text-cream/70 hover:text-cream transition-colors">
            <Mail className="w-5 h-5" strokeWidth={1.5} />
          </a>
        </div>
      </div>
      <div>
        <p className="text-xs uppercase tracking-widest text-rosegold mb-4">Explore</p>
        <ul className="space-y-2 text-cream/75">
          <li><Link to="/shop" className="hover:text-cream transition-colors">Shop</Link></li>
          <li><Link to="/pre-orders" className="hover:text-cream transition-colors">Pre-Orders</Link></li>
          <li><Link to="/about" className="hover:text-cream transition-colors">About</Link></li>
          <li><Link to="/size-guide" className="hover:text-cream transition-colors">Size Guide</Link></li>
          <li><Link to="/faq" className="hover:text-cream transition-colors">FAQ</Link></li>
        </ul>
      </div>
      <div>
        <p className="text-xs uppercase tracking-widest text-rosegold mb-4">Join the pack</p>
        <p className="text-cream/75 text-sm mb-4">Be first to hear about new drops &amp; pre-orders.</p>
        <WaitlistForm source="footer" compact />
      </div>
    </div>
    <div className="border-t border-cream/15">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-cream/50">
        <p>© {new Date().getFullYear()} Hound Oz. Designed in Australia, with love for hounds everywhere.</p>
        <p>Cream · Maroon · Rose Gold</p>
      </div>
    </div>
  </footer>
);
